import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  const navLinks = [
    { path: '/', label: 'Accueil' },
    { path: '/location-vtc', label: 'Location VTC' },
    { path: '/comment-ca-marche', label: 'Comment ça marche' },
    { path: '/contact', label: 'Contact' },
  ];

  return (
    <nav
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'glass py-3' : 'bg-transparent py-5'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link
            to="/"
            data-testid="logo-link"
            className="flex items-center gap-2 group"
          >
            <span className="font-['Outfit'] text-2xl font-bold text-white tracking-tight">
              LUXEO
            </span>
            <span className="font-['Outfit'] text-2xl font-light text-[#D4AF37]">
              CAR
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`nav-${link.path.replace('/', '') || 'home'}`}
                className={`nav-link font-['Manrope'] text-sm font-medium uppercase tracking-wider ${
                  location.pathname === link.path ? 'text-[#D4AF37]' : ''
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/contact"
              data-testid="nav-cta-btn"
              className="btn-primary text-sm font-bold px-6 py-3"
            >
              Demande de location
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            data-testid="mobile-menu-btn"
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden text-white p-2 hover:text-[#D4AF37] transition-colors"
            aria-label="Toggle menu"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        data-testid="mobile-menu"
        className={`md:hidden mobile-menu fixed inset-0 top-[60px] transition-transform duration-300 ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="flex flex-col items-center justify-center gap-8 pt-20">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              data-testid={`mobile-nav-${link.path.replace('/', '') || 'home'}`}
              className={`font-['Outfit'] text-2xl font-medium ${
                location.pathname === link.path
                  ? 'text-[#D4AF37]'
                  : 'text-white hover:text-[#D4AF37]'
              } transition-colors`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/contact"
            data-testid="mobile-nav-cta-btn"
            className="btn-primary text-lg font-bold px-8 py-4 mt-4"
          >
            Demande de location
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
